document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('.newsletter-popup');
  if (!popup) return;

  var cookieName = 'newsletter_popup_dismissed';
  var cookieDays = parseInt(popup.dataset.cookieDays || '14', 10);
  var delay = parseInt(popup.dataset.delay || '5000', 10);

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function show() {
    popup.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function hide(remember) {
    popup.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (remember) setCookie(cookieName, '1', cookieDays);
  }

  // Don't show if already submitted or dismissed, or if just redirected back after a successful submit
  var justSubmitted = popup.querySelector('.newsletter-popup__success');
  if (getCookie(cookieName) && !justSubmitted) return;

  if (justSubmitted) {
    show();
  } else {
    setTimeout(show, delay);
  }

  popup.querySelector('.newsletter-popup__close').addEventListener('click', function () {
    hide(true);
  });
  popup.querySelector('.newsletter-popup__dismiss').addEventListener('click', function () {
    hide(true);
  });
  popup.querySelector('.newsletter-popup__overlay').addEventListener('click', function () {
    hide(true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide(true);
  });

  var form = popup.querySelector('#newsletter-popup-form');
  if (form) {
    form.addEventListener('submit', function () {
      setCookie(cookieName, '1', cookieDays);
    });
  }
});